module.exports = __webpack_public_path__ + "img/no-single-item@2x.99affb0b.png";